import React, { useEffect, useState } from "react";
import { Upload } from "antd";
import { APIURL } from "../../../constant/common";
import { ReactComponent as UploadScreenshotsPlaceholder } from "../../../assets/svg/uploadScreenshotsPlaceholder.svg";
import { Http } from "../../../helpers/axois";
import "./styles/upload-screenshots.scss";
import { GCPENDPOINT } from "../../../constant/common";
import { useToast } from '../../../helpers/commonFunction'
import { logger } from "../../../constant/winston";
import { beforeUpload } from "../../../helpers/fileHelper";



const { Dragger } = Upload;

interface IProps {
  setScreenshots: (key: string, value: any, isArray: boolean) => void;
  orgId: string;
  screenshots: any;
  setWidget: any;
}

const UploadScreenshots: React.FC<IProps> = ({ setScreenshots, orgId, screenshots, setWidget }) => {
  const [count, setCount] = useState<number>(0);
  const [previewList, setPreviewList] = useState<any[]>([]);
  const { SuccessToast, ErrorToast } = useToast();

  useEffect(() => {
    const previewList = screenshots && screenshots.map((screenshot: string, id: number) => ({
      edit: true,
      uid: id,
      src: screenshot?.startsWith("https://") ? screenshot : GCPENDPOINT + screenshot,
    }))
    if(screenshots.length > 5) {
      return
    }
    setCount(screenshots.length)
    setPreviewList(previewList)
  }, [screenshots])

  const uploadImage = async (options: any) => {
    const { file } = options;
    const formData = new FormData();
    const name = `${Math.random()
      .toString(36)
      .substring(2)}-${Date.now().toString(36)}_${file.name}`;
      
    formData.append("file", file, name);
    const shoudUpload = beforeUpload(file)
    if (shoudUpload.ok) {
      try {
        const res: any = await Http.post(`${APIURL}/orgs/${orgId}/store/products/image/upload`, formData).toPromise();
        setScreenshots('screenshots', res.url, true)
        SuccessToast("File uploaded")
      } catch (e) {
        logger.error(e)
        ErrorToast("Screenshot upload failed");
      }
    } else {
      ErrorToast(shoudUpload.message)
    }
  };

  const draggerProps = {
    multiple: true,
    showUploadList: false,
    accept: "image/*",
    maxCount: 5,
    disabled: screenshots.length >= 5,
    customRequest: uploadImage,
  };

  const handleRemoveId = (e: { stopPropagation: () => void; }, el: any) => {
    e.stopPropagation()
    const path = new URL(el.src).pathname;
    const fileName = decodeURI(path.split("/").slice(2).join("/"));
    const endpoint = `/orgs/${orgId}/store/products/image/remove`
    const filePath = new URL(el.src || '').pathname; 
    setWidget((prevState: any) => ({ ...prevState, screenshots: prevState.screenshots.filter((item: any) => item !== filePath) }))
    Http.put(endpoint, { data: { files: { fileName } } }).subscribe((res: any) => {
      SuccessToast("Deleted screenshot")
    }, (err) => {
      logger.error(err)
      // ErrorToast(err.message)
    })
  };

  return (
    <div className="upload-screenshots">
      <div className="upload-screenshots-header">
        <h5>Application Preview & Screenshots</h5>

        <div>
          <span className="hl">{count} / 5</span> <span className="sec">|</span>{" "}
          <span className="hl">Choose file</span>
        </div>
      </div>

      <Dragger {...draggerProps}>
        <div className="upload-screenshots-content">
          {!previewList.length ? (
            <div className="holder">
              <UploadScreenshotsPlaceholder />
              <span>Drag up to 5 images here</span>
            </div>
          ) : (
            <FilePreviewList previewList={previewList} count={count} handleRemoveId={handleRemoveId} />
          )}
        </div>
      </Dragger>
    </div>
  );
};

interface IPreviewListProps {
  previewList: any[];
  count: number;
  handleRemoveId: any;
}

const FilePreviewList: React.FC<IPreviewListProps> = ({
  previewList,
  count,
  handleRemoveId,
}) => {
  return (
    <div className="file-preview-list">
      {previewList.map((el, index) => (
        <div key={index} >
          <img
            data-test-id="file_preview_list"
            key={el.uid}
            src={el.edit ? el.src : URL.createObjectURL(el.originFileObj)}
            alt="file-preview" />
          <button type="button" className="close-btn" aria-label="Close" onClick={(e) => handleRemoveId(e, el)}> X </button>
        </div>
      ))}
    </div>
  );
};

export default UploadScreenshots;
